angular.module('skeyenoteWebApp').directive('ngEnter', NgEnterDirective);

function NgEnterDirective() {
  return function(scope, element, attrs) {
    element.bind('keydown keypress', function(event) {
      if (event.which === 13) {
        if (!event.shiftKey) {
          scope.$apply(function() {
            scope.$eval(attrs.ngEnter);
          });
        }
        event.preventDefault();
      }
    });
  };
}
